// src/api/axios.js
import axios from 'axios';
import { handleSessionExpiry } from '../auth/sessionExpiry';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
if (process.env.NODE_ENV !== 'production') {
  console.info(`[api] baseURL: ${apiBaseUrl}`);
}

const api = axios.create({
  baseURL: apiBaseUrl,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    handleSessionExpiry(error);
    return Promise.reject(error);
  }
);

export default api;
